import React from 'react';
import { makeStyles, Box, Grid } from '@material-ui/core';
const OurServiceSection = ({ item }) => {
	return (
		<>
			<Grid item xs={12} md={6} lg={4}>
			<div className='box' data-aos='zoom-in'>
				<span>{item.id}</span>
				<i className={item.fontawesomeIcon}></i>
				<h3>{item.title}</h3>
				<p>{item.desc}</p>
			</div>
			</Grid>
			
		</>
	);
};

export default OurServiceSection;
